// import React from 'react'

// const Comments = () => {
//   return (
//     <div>Comments</div>
//   )
// }

// export default Comments
import React, { useEffect } from "react";
import {
  FormFieldSet,
  useFormHandler,
} from "../../../../../../../../components";
import { setCurrentPayrollEditing } from "../../../../../../../../redux/slices/payroll/payrollSlice";
import { useDispatch, useSelector } from "react-redux";

const Comments = ({disableEditing}) => {
  const dispatch = useDispatch();
  const { currentPayrollEditing } = useSelector((state) => state.payRoll) || {};
  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    comments: "",
  });
  useEffect(() => {
    dispatch(
      setCurrentPayrollEditing({
        tabswitched: true,
      })
    );
    if (currentPayrollEditing?.comments !== formData.comments) {
      handleChange("comments", currentPayrollEditing?.comments || "");
    }
  }, [currentPayrollEditing?.comments]);

  useEffect(() => {
    if (formData.comments) {
      dispatch(
        setCurrentPayrollEditing({
          comments: formData.comments,
        })
      );
    }
  }, [formData.comments]);

  return (
    <div className="grid grid-cols-2 max-w-7xl gap-x-10 gap-y-6 mt-4 mb-5 p-4">
      <FormFieldSet
        type="textArea"
        title="Payroll Notes"
        placeholder="Comments"
        value={formData.comments}
        onChange={(value) => handleChange("comments", value)}
        error={errors.comments}
        disabled={disableEditing}
      />
    </div>
  );
};

export default Comments;
